export default "__VITE_ASSET__Dh_GX6Ml__"